



















































































































































































import { Mixins, Component, Ref } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';
import * as E from '@/enums';

import AxAPI from '@/api';

type Group = I.AxZone;
type Group1 = I.CodeData;
type Item = I.MonitorGroupList;

type GroupListPanel = I.AxGroupListPanel<Group, Item>;
type PageInfo = I.MonitoringPageInfo;

type DataItem = U.DataItem<unknown, State>;
type DataStore = U.DataStore<unknown, never>;

const DataStore = U.DataStore;

type UpdateItemParam = I.PacketMonitorUpdate;

interface DoorData {
  num: number;
  dataTypeName: string;
  name: string;
}

class State {
  name: string;
  code: number;
  etc: string;
  zoneCode: number;
  zoneName: string;
  map: string | ArrayBuffer | null;
  listElement: I.MonitorElement[];
  listAccount: I.MonitorAccount[];
  listDoor: I.MonitorDoor[];
  listSensor: I.MonitorSensor[];
  listOutput: I.MonitorOutput[];
  itemStatus: E.ItemStatus;

  constructor() {
    this.name = '' as never;
    this.code = '0' as never;
    this.etc = '' as never;
    this.zoneCode = '0' as never;
    this.zoneName = '' as never;
    this.map = '' as never;
    this.listElement = [];
    this.listAccount = [];
    this.listDoor = [];
    this.listSensor = [];
    this.listOutput = [];
    this.itemStatus = E.ItemStatus.None;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  panel!: GroupListPanel;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await this.API.call.monitor.groupPageInfo();
    console.log('pageInfo', result);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async updateItem(item: UpdateItemParam) {
    console.log('item', item);
    const result = await this.API.call.monitor.groupUpdate(item);
    console.log('result', result);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '도어 테이블',
      store: new DataStore<DoorData>({
        headers: {
          num: '순번',
          dataTypeName: '카테고리',
          name: '설명'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class GroupPanelHandler extends BaseClass {
  onListGroupChanged(group?: Group) {
    if (!this.pageInfo || !group) return;

    if (this.panel.items) {
      this.panel.items = this.pageInfo.listGroup.filter(x => x.zoneCode === group.code);
    }
  }

  onListItemChanged(item?: Item) {
    console.log('items', item);
    if (item) {
      this.dataItem.state.zoneCode = item.zoneCode;
      this.dataItem.state.code = item.code;
      this.dataItem.state.name = item.name;
      this.dataItem.state.etc = item.etc;
      if (item.map) {
        this.dataItem.state.map = 'data:image/png;base64, ' + item.map;
      } else this.dataItem.state.map = null;
      const listDoor = item.listElement;
      this.tableParam.items = item.listAccount;
      this.dataItem.state.listAccount = item.listAccount;
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
      console.log('element', listDoor);
      this.dataItem.store.setItems(listDoor);
    } else {
      this.dataItem.state = new State();
      this.dataItem.state.itemStatus = E.ItemStatus.None;
    }
  }

  onListAddClicked(group: Group) {
    this.dataItem.state = new State();
    this.dataItem.state.zoneCode = group.code;
    this.dataItem.state.zoneName = group.name;
    this.dataItem.state.code = 0;
    this.dataItem.state.name = '';
    this.dataItem.state.etc = '';
    this.tableParam.items = [];
    this.dataItem.state.map = '';
    this.dataItem.state.itemStatus = E.ItemStatus.New;
    const listDoor = [];
    this.dataItem.store.setItems(listDoor);
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  panel: GroupListPanel = {
    groups: [],
    items: [],
    group: -1,
    item: -1
  };

  listAccessType: Group1[] = [
    { code: '10', name: 'Normal' },
    { code: '50', name: 'Administrator' },
    { code: '100', name: 'Engineer' }
  ];

  pageInfo = {} as PageInfo;
  zoneCode = 0;
}

const Handlers = Mixins(ApiHandler, DataItemHandler, GroupPanelHandler);

@Component
export default class MonitorGroup extends Mixins(BaseData, Handlers) {
  async prepare() {
    const pageInfo = await this.getPageInfo();
    if (pageInfo) {
      this.pageInfo = pageInfo;
      this.panel.groups = this.getZoneList();
      this.panel.items = pageInfo.listGroup;
    }
  }

  tableParam = new DataStore<I.MonitorAccount>({
    headers: {
      loginid: { text: 'ID', width: 30, align: 'left', sortable: false },
      mcontrol: { text: 'C', width: 10, align: 'center', sortable: false },
      eventSearch: { text: 'E', width: 10, align: 'center', sortable: false }
    }
  });

  @Ref()
  fileUpload!: HTMLInputElement;

  async onSaveClicked() {
    console.log('item', this.dataItem.state);
    const { itemStatus } = this.dataItem.state;
    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag =
      itemStatus === E.ItemStatus.New ? E.EUpdateFlag.Insert : E.EUpdateFlag.Update;

    const groupID = this.dataItem.state.code;
    const zoneCode = this.dataItem.state.zoneCode;
    const name = this.dataItem.state.name;
    const etc = this.dataItem.state.etc;
    const width = 0;
    const height = 0;
    const backAlpha = 0;
    const listAccount = this.tableParam.items;
    const listDoor = this.dataItem.store.items;

    console.log(this.dataItem.state);
    if (name === '') {
      await this.showErrorModal('오류', '이름을 입력 해주세요.');
      return;
    }
    // } else if (listDoor. === 0) {
    //   await this.showErrorModal('오류', '리더기를 선택 해주세요.');
    //   return;
    // }

    const title = '확인';
    const message =
      itemStatus === E.ItemStatus.New
        ? '입력한 아이템을 추가할까요?'
        : '선택한 아이템을 수정할까요?';
    const buttons = ['네', '아니오'];

    const confirm = await this.showConfirmModal(title, message, buttons);
    if (confirm !== 0) return;

    this.setLoading(true);
    const result = await this.updateItem({
      groupID,
      zoneCode,
      name,
      etc,
      width,
      height,
      backAlpha,
      listAccount,
      listDoor,
      updateFlag
    });

    console.log('result', result.groupID);

    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      if (this.fileUpload.files && this.fileUpload.files.length > 0) {
        await this.SaveMap(result.groupID);
      }
    }

    this.onUpdated(result, updateFlag);
  }

  async SaveMap(groupID: number) {
    if (!this.fileUpload.files) return;
    const formData = new FormData();
    const file = this.fileUpload.files[0];
    console.log('file', file);
    formData.append('file', file, file.name);
    formData.append('groupID', groupID.toString());
    this.API.call.monitor.map(formData);
  }

  async onDeleteClicked() {
    const { code, itemStatus } = this.dataItem.state;
    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag = E.EUpdateFlag.Delete;

    const confirm = await this.showConfirmModal('확인', '선택된 아이템을 삭제할까요?', [
      '네',
      '아니오'
    ]);
    if (confirm !== 0) return;

    const groupID = this.dataItem.state.code;
    const zoneCode = this.dataItem.state.zoneCode;
    const name = this.dataItem.state.name;
    const etc = this.dataItem.state.etc;
    const width = 0;
    const height = 0;
    const backAlpha = 0;
    const listAccount = this.tableParam.items;
    const listDoor = this.dataItem.store.items;

    this.setLoading(true);
    const result = await this.updateItem({
      groupID,
      zoneCode,
      name,
      etc,
      width,
      height,
      backAlpha,
      listAccount,
      listDoor,
      updateFlag
    });
    this.setLoading(false);
    if (!result) return;

    this.onUpdated(result, E.EUpdateFlag.Delete);
  }

  async onUpdated(result: Item, updateFlag: E.EUpdateFlag) {
    if (!this.pageInfo) return;
    const prevGroup = this.panel.group;
    this.panel.groups = [];
    this.panel.items = [];

    await this.prepare();
    await this.$nextTick();

    this.panel.group = prevGroup;

    if (updateFlag !== E.EUpdateFlag.Delete) {
      this.panel.item = this.panel.items.findIndex(x => x.code === result.code);
    }

    if (updateFlag === E.EUpdateFlag.Insert) {
      const zones: I.ZoneDetail[] = JSON.parse(JSON.stringify(this.pageInfo.listZone));
      const latest = zones.sort((a, b) => b.code - a.code)?.[0];
      console.log(latest);
      if (latest) {
        const targetIndex = this.panel.items.findIndex(x => x.code === latest.code);
        this.panel.item = targetIndex;
      }
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
      await this.showErrorModal('알림', '추가되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Update) {
      await this.showErrorModal('알림', '수정되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Delete) {
      this.dataItem.state = new State();
      this.panel.item = -1;
      await this.showErrorModal('알림', '삭제되었습니다');
    }
  }

  async onClearClicked() {
    const confirm = await this.showConfirmModal('확인', '입력중인 내용을 취소할까요?', [
      '네',
      '아니오'
    ]);

    if (confirm === 0) {
      this.dataItem.state = new State();
    }
  }

  OnClickAccountInformationFilterSetting(e: Event) {
    console.log(e);
    this.navigate({
      controller: 'Config',
      action: 'AccountInformationFilterSettings',
      groupId: e.groupId
    });
  }

  OnFilterClicked() {
    type FilterlistParams = { title: string; param: I.DataParam };
    const dialogParams = new I.DialogParam<FilterlistParams>('AxAccountFilterDialog', {
      title: '필터 설정',
      param: {
        items: [this.dataItem.state],
        headers: [{ text: '이름', value: 'name', align: 'start' }],
        selected: [this.dataItem.state],
        callback: async () => {
          if (dialogParams.props.param.selected[0].companycodeFilterList) {
            this.dataItem.state.companycodeFilterList =
              dialogParams.props.param.selected[0].companycodeFilterList;
          }
          if (dialogParams.props.param.selected[0].deptcodebFilterList) {
            this.dataItem.state.deptcodebFilterList =
              dialogParams.props.param.selected[0].deptcodebFilterList;
          }
        }
      }
    });
    this.showDialog(dialogParams);
  }

  getBase64(file: File) {
    const state = this.dataItem.state;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {
      if (reader.result) state.map = reader.result;
    };
    reader.onerror = function(error) {
      console.log('Error: ', error);
    };
  }

  upload() {
    this.fileUpload.click();
  }

  OnFileChange() {
    if (this.fileUpload.files) this.getBase64(this.fileUpload.files[0]);
  }

  OnTypeSelectChange() {
    let listIdx: number[] = [];
    if (this.dataItem.state.privType === '10') {
      listIdx = [1, 21, 22, 23, 71, 72, 81, 121, 122];
    } else if (this.dataItem.state.privType === '50') {
      listIdx = [
        1,
        21,
        22,
        23,
        31,
        51,
        61,
        71,
        72,
        75,
        76,
        81,
        91,
        101,
        121,
        122,
        141,
        142,
        143,
        391
      ];
    } else if (this.dataItem.state.privType === '100') {
      listIdx = [
        1,
        21,
        22,
        23,
        31,
        51,
        61,
        71,
        72,
        75,
        76,
        81,
        91,
        101,
        121,
        122,
        141,
        142,
        143,
        151,
        171,
        181,
        191,
        211,
        231,
        241,
        351,
        361,
        371,
        391
      ];
    }
    const selectedAccount1 = this.pageInfo.listMenu.filter((menu, idx, source) =>
      listIdx.includes(menu.idx)
    );
    this.dataItem.state.selected = selectedAccount1;
  }

  OnSelectAdministrator() {
    type ZonelistParams = { title: string; param: I.DataParam };
    const dialogParams = new I.DialogParam<ZonelistParams>('AxMonitorSelectAdministratorDialog', {
      title: '구역 선택',
      param: {
        items: this.pageInfo.listAccount,
        headers: [{ text: '관리자', value: 'loginid', align: 'start' }],
        selected: this.dataItem.state.listAccount,
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.MonitorAccount[];
          this.dataItem.state.listAccount = selected;
          this.tableParam.items = selected;
        }
      }
    });
    console.log('dialog', dialogParams);
    this.showDialog(dialogParams);
  }

  OnSelectAnElement() {
    // type PasswordParams = { title: string; param: I.DataParam };
    // const dialogParams = new I.DialogParam<PasswordParams>('AxMonitorSelectAnElementDialog', {
    //   title: '암호 입력',
    //   param: {
    //     items: [this.pageInfo.listDoor],
    //     headers: [{ text: '이름', value: 'name', align: 'start' }],
    //     selected: [this.dataItem.state.listElement],
    //     callback: async () => {
    //       if (dialogParams.props.param.selected[0].password) {
    //         this.dataItem.state.password = dialogParams.props.param.selected[0].password;
    //       }
    //       console.log('state', this.dataItem.state);
    //     }
    //   }
    // });
    // this.showDialog(dialogParams);

    type GroupPrivParams = { title: string; param: I.DataParam };

    console.log('page', this.pageInfo);
    const listAllDoor = this.pageInfo.listDoor.filter(
      x => x.groupID === this.dataItem.state.zoneCode
    );
    if (!listAllDoor) return;

    const listDoor = this.dataItem.store.items;

    console.log('all', listAllDoor);
    console.log('door', listDoor);

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 선택',
      param: {
        items: listAllDoor,
        selected: listDoor,
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorData[];
          const remain = this.dataItem.state.listDoor.filter(
            x => x.groupID !== this.dataItem.state.zoneCode
          );

          console.log('출입문 그룹 callback', remain, selected);

          this.dataItem.store.items = selected;
        }
      }
    });
    this.showDialog(dialogParams);
  }
}
